import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IdentityPoolsPickerDialogBody, IdentityPoolsPickerDialogBodyProps, IdentityPoolsPickerDialogBodyState } from '../IdentityPoolsPickerDialogBody';

export function showIdentityPoolSelectionBasedActionDialog(dialogTitle: string, confirmText: string, dialogDescription: string,
    identityPools: IIdentityPool[], isDelete: boolean, myAction: (identityPool: IIdentityPool) => Promise<IResult>): Promise<IResult> {

  const modalInstance = openReactActionDialog<IdentityPoolsPickerDialogBodyProps, IdentityPoolsPickerDialogBodyState, IResult>({
    title: dialogTitle,
    bodyComponent: IdentityPoolsPickerDialogBody,
    initialBodyProps: { dialogDescription: dialogDescription, identityPools: identityPools },
    initialDialogState: { selectedIdentityPool: null },
    actionName: confirmText,
    action: (props: IdentityPoolsPickerDialogBodyProps, state: IdentityPoolsPickerDialogBodyState) => myAction(state.selectedIdentityPool),
    dialogWidth: TabDialogWidth.width500px,
    dismissDialogOnActionFailed: true,
    isActionDelete: isDelete,
    initiallyFocusedElement: (dialogElement) => dialogElement.querySelector('button[aria-haspopup]')
  });

  return modalInstance.result;
}
